import { addSeconds, differenceInSeconds } from "date-fns";
import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { getDateFromString } from "@circle-react/helpers/dateTimeHelpers";
import { DateTimePicker } from "@circle-react-uikit/DateTimePicker";

export interface DateRangePickerProps {
  disabled?: boolean;
  durationConfig: { name: string };
  endsAtConfig: { name: string };
  startsAtConfig: {
    name: string;
    minDate: Date;
  };
}

export const DateRangePicker = ({
  startsAtConfig,
  endsAtConfig,
  durationConfig,
  disabled = false,
}: DateRangePickerProps) => {
  const { register, setValue, getValues } = useFormContext();
  const dateFormValue = getValues(startsAtConfig.name) as string;
  const startDate = getDateFromString(dateFormValue);

  const onStartDateChange = (value: Date) => {
    const duration = getValues(durationConfig.name) as number;
    const endDate = addSeconds(value, duration);

    setValue(endsAtConfig.name, endDate);
  };

  const onEndDateChange = () => {
    const startDateValue = getValues(startsAtConfig.name) as string;
    const startDate = getDateFromString(startDateValue);
    const endDateValue = getValues(endsAtConfig.name) as string;
    const endDate = getDateFromString(endDateValue);

    const duration = differenceInSeconds(endDate, startDate);
    if (duration < 0) return;

    setValue(durationConfig.name, duration, {
      shouldDirty: true,
    });
  };

  return (
    <div className="flex flex-col items-start gap-2 md:flex-row md:items-center">
      <DateTimePicker
        name={startsAtConfig.name}
        onChange={onStartDateChange}
        minDate={startsAtConfig.minDate}
        dataTestId="event_starts_at"
        disabled={disabled}
      />
      <div className="mx-2">{t("to")}</div>
      <DateTimePicker
        name={endsAtConfig.name}
        onChange={onEndDateChange}
        minDate={startDate}
        dataTestId="event_ends_at"
        disabled={disabled}
      />
      <div className="hidden">
        <input type="hidden" {...register(durationConfig.name)} />
      </div>
    </div>
  );
};
